import _ from 'lodash'

const ReportFilterUtil = {
	hasValues: function(attrs, field) {
		return _.get(attrs, 'filters.'+field+'[0].values.length', 0) != 0
	},
	hasAncestorValues: function(attrs, field) {
		return _.get(attrs, 'filters.'+field+'[0].ancestorValues.length', 0) != 0
	}
}

export default ReportFilterUtil
ReportFilterUtil.__filename__ = 'reports/wizard/common/report-filter-util.js'
